import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { t } from '../../../../../../i18n';
import { ARROW_LEFT, ARROW_RIGHT } from '../../../../../navigation-arrow/navigationArrow.constants';
import { NavigationArrow } from '../../../../../navigation-arrow/navigationArrow.component';
import { SELECTED_SIGNAL } from '../../../../../signals';
import { defaultContext, getInitialStyle } from './epgPopupHeader.style';

export class EpgPopupHeader extends Lightning.Component {
  static _template() {
    return _merge(
      {
        ArrowLeft: {
          type: NavigationArrow,
          variant: ARROW_LEFT,
        },
        ArrowRight: {
          type: NavigationArrow,
          variant: ARROW_RIGHT,
        },
        Title: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._titles = [t('epgGrid.lastWeek'), t('epgGrid.currentWeek'), t('epgGrid.nextWeek')];
    this._index = 1;
  }

  _build() {
    this._focused = 'ArrowLeft';
    this.title = this._titles[this._index];
  }

  set title(value) {
    this.tag('Title').text.text = value;
  }

  set index(value) {
    if (value !== this._index) {
      this._index = value;
      this.title = this._titles[this._index];
      this.tag('ArrowLeft').disabled = this._index < 1;
      this.tag('ArrowRight').disabled = this._index > 1;

      if (this.tag('ArrowLeft').disabled) {
        this._focused = 'ArrowRight';
      } else if (this.tag('ArrowRight').disabled) {
        this._focused = 'ArrowLeft';
      }

      // transforming 0..2 into -1..1
      this.signal(SELECTED_SIGNAL, this._index - 1);
    }
  }

  _handleLeft() {
    if (this.tag('ArrowLeft').disabled) {
      return true;
    }

    this._focused = 'ArrowLeft';

    return true;
  }

  _handleRight() {
    if (this.tag('ArrowRight').disabled) {
      return true;
    }

    this._focused = 'ArrowRight';

    return true;
  }

  _handleEnter() {
    if (this._focused === 'ArrowLeft') {
      this.index = Math.max(this._index - 1, 0);
    } else if (this._focused === 'ArrowRight') {
      this.index = Math.min(this._index + 1, this._titles.length - 1);
    }

    return true;
  }

  _getFocused() {
    return this.tag(this._focused);
  }
}
